import React from 'react';

import { cn } from '../../lib/utils';

const ModalSubtitle = ({ children, className, ...props }) => {
  return (
    <p className={cn('text-xs/5 font-medium text-gray-400 dark:text-neutral-500', className)} {...props}>
      {children}
    </p>
  );
};

export { ModalSubtitle };
